import { OktaConfigInterface } from "./okta-config-interface";

export const environment = {
  production: true,
  sparkNewFlowToggle: false,
  parentPortalWebUrl: 'https://nhaparentportal.com',
  cmsBaseUrl: 'https://www.nhaschools.com',
  apiUrl: 'https://app.nhaschools.com/api',
  baseUrl: 'https://app.nhaschools.com/',
  oktaConfig: {
    // Base configuration shared by all login types
    scopes: ['openid', 'profile', 'email', 'phone', 'offline_access'],
    pkce: true,
    testing: {
      disableHttpsCheck: false
    }
  } as OktaConfigInterface,
  // login type configurations
  oktaLoginTypes: {
    Staff: {
      clientId: '0oarqj1yqbnjDR2Ft4x7',
      issuer: 'https://sso.nhaschools.com/oauth2/default',
      //redirectUri: window.location.origin + '/callback',
      redirectUri: 'https://app.nhaschools.com/callback',
      signOutRedirectURI: 'https://sso.nhaschools.com/oauth2/default/v1/logout',
      authorize: 'https://sso.nhaschools.com/oauth2/default/v1/authorize',
      token: 'https://sso.nhaschools.com/oauth2/default/v1/token',
      userInfo: 'https://sso.nhaschools.com/oauth2/default/v1/userinfo'
    },
    Student: {
      clientId: '0oarqj1yqbnjDR2Ft4x7',
      issuer: 'https://sso.nhaschools.com/oauth2/default',
      //redirectUri: window.location.origin + '/callback',
      redirectUri: 'https://app.nhaschools.com/callback',
      signOutRedirectURI: 'https://sso.nhaschools.com/oauth2/default/v1/logout',
      authorize: 'https://sso.nhaschools.com/oauth2/default/v1/authorize',
      token: 'https://sso.nhaschools.com/oauth2/default/v1/token',
      userInfo: 'https://sso.nhaschools.com/oauth2/default/v1/userinfo'
    },
    Parent: {
      clientId: '0oap1y0rjrY60XgZa5d7',
      issuer: 'https://nhaparents.okta.com/oauth2/default',
      //redirectUri: window.location.origin + '/callback',
      redirectUri: 'https://app.nhaschools.com/callback',
      signOutRedirectURI: 'https://nhaparents.okta.com/oauth2/default/v1/logout',
      authorize: 'https://nhaparents.okta.com/oauth2/default/v1/authorize',
      token: 'https://nhaparents.okta.com/oauth2/default/v1/token',
      userInfo: 'https://nhaparents.okta.com/oauth2/default/v1/userinfo'
    }
  }
};
